<template lang="pug">
  component(
    v-bind="componentProps",
    ref="menuElement",
    class="menu-item"
  )
    a.menu-item__link(
      v-if="newApp"
      :href="path"
      :aria-label="`Click on ${name} link`"
      :class="{'is--not-clickable': !clickable}"
    )
      span {{ name }}
      SolidSortDownIcon.menu-item__link-icon(v-if="hasChildren").svg-icon.sort-down-icon
    router-link.menu-item__link(
      v-else
      :to="path"
      :aria-label="`Click on ${name} link`"
      :class="{'is--not-clickable': !clickable}"
    )
      span {{name}}
      SolidSortDownIcon.menu-item__link-icon(v-if="hasChildren").svg-icon.sort-down-icon
    ul.dropdown-menu(
      v-if="hasChildren",
    )
      template(
        v-for="(subMenuItem, index) in children",
      )
        router-link.dropdown-menu__item(
          v-if="subMenuItem.path.startsWith('/') && !subMenuItem.newApp"
          :key="index"
          tag="li",
          :to="subMenuItem.path",
        )
          a.dropdown-menu__item-link(:aria-label="`Click on ${subMenuItem.name} link`")
            span {{subMenuItem.name}}
        li.dropdown-menu__item(
          v-else-if="subMenuItem.newApp"
          :key="index"
        )
          a.dropdown-menu__item-link(
            :href="subMenuItem.path"
            :aria-label="`Click on ${subMenuItem.name} link`"
          ) {{subMenuItem.name}}
        li.dropdown-menu__item(
          v-else
          :key="index"
          :aria-label="`Click on ${subMenuItem.name} link`"
        )
          a.dropdown-menu__item-link(
            :href="subMenuItem.path"
            target="_blank"
          ) {{subMenuItem.name}}
</template>

<script>
import SolidSortDownIcon from 'images/svg-icons/new-chevron-down.svg?component';

export default {
  name: 'TheHeaderMenuItem',
  components: { SolidSortDownIcon },
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true,
    },
    path: {
      type: String,
    },
    children: {
      default: () => ([]),
      type: Array,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
    newApp: Boolean,
  },
  computed: {
    hasChildren() {
      return this.children.length;
    },
    componentProps() {
      if (this.hasChildren || this.newApp) return { is: 'li' };
      return {
        is: 'router-link',
        to: this.path,
        tag: 'li',
      };
    },
  },
};
</script>

<style lang="sass" scoped>
  @import '~Styles/_variables'
  .dropdown-menu
    position: absolute
    padding-top: 10px
    padding-bottom: 10px
    cursor: pointer
    overflow: hidden
    visibility: hidden
    background-color: #fff
    opacity: 0
    +mt(.1s)
    +elevation(1)
    top: 64px
    width: 146px
    min-width: max-content
    left: 50%
    transform: translate(-50%, 0px)
    @media screen and (max-width: 767px)
      position: relative
      height: 0
      top: 0
    &__item
      background-color: #fff
      padding: 0
      width: 100%
      margin: 1px 0
      pointer-events: none
      display: flex
      &:hover
        transition: all 0.3s ease-in-out
        .dropdown-menu__item-link
          color: $text_gray
    &__item-link
      font-size: 14px
      line-height: 20px
      +font(500)
      color: $primary
      padding: 10px 20px
      width: 100%
      display: flex
  .menu-item
    margin: 0 15px
    position: relative
    display: flex
    align-items: center
    cursor: pointer
    @media screen and (max-width: 1024px)
      margin: 0 10px
    &:hover
      .dropdown-menu
        visibility: visible
        opacity: 1
        +mt(.1s)
        .dropdown-menu__item
          z-index: 1
          pointer-events: auto
        @media screen and (max-width: 767px)
          position: relative
          height: 100%
          padding-bottom: 40px
    &__link
      padding: 25px 0
      font-size: 14px
      display: flex
      align-items: center
      &.is--not-clickable
        pointer-events: none
    &__link-icon
      margin-left: 4px
      position: relative
      width: 16px
      height: 16px
      fill: $text_gray
    &:last-child
      margin-right: 0
    &:first-child
      margin-left: 0
</style>
